<template>
  <div class="refresh-icon">
    <v-icon
      :class="{ 'updating-status' : state }"
    >
        mdi-refresh
    </v-icon>
  </div>
</template>

<script>

export default {
  name: 'RefreshLoader',
  props: {
    state: {
      required: true,
      type: Boolean
    }
  }
}
</script>

<style lang="scss" scoped>
  .refresh-icon {
    position: absolute;
    right: 15px;
    top: 10px;
    &:hover {
      cursor: pointer;
    }
  }
  .updating-status {
    animation-name: spin;
    animation-duration: 750ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear; 
  }

  @keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
  }
</style>